
import React from "react";
import { Ship } from "lucide-react";
import HistoryIcon from "@mui/icons-material/History";
import { MilestoneComments } from "../AirTracking/Milestonecomments";
function OceanMileStoneTracking({ ports, firstAndLast }: { ports: any[], firstAndLast: any }) {
    const [showHistoryBoxNew, setShowHistoryBoxNew] = React.useState(false);
    const [dialogIndexNew, setdialogIndexNew] = React.useState<number | null>(
        null
    );

    const handleHistoryCloseNew = () => {
        setShowHistoryBoxNew(false);
        setdialogIndexNew(null);
    };
    const handleHistoryOpenNew = (port: any, index: number) => {
        setShowHistoryBoxNew(true);
        setdialogIndexNew(index);
    };
    return <>
        {firstAndLast.first.length > 0 && <><div className="roadmapHeading RoadMapPreCarriageHeading">
            <h3>Pre-Carriage</h3>
        </div>
            <div className="RoadMap RoadMapPreCarriage">
                <div className="relative mx-auto max-w-screen-lg px-0  lg:px-3 ms:px-3 sm:px-0">
                    <div className="relative justify-between mb-[0px] text-xs">
                        {/* <div className="bg-green-500"></div> */}

                        {firstAndLast.first.map((element: any, index: number) => (


                            <div
                                key={index}
                                className="relative roadinn h-[100px]  flex flex-col items-center w-full mb-5"
                            >
                                <div
                                    className={`w-[20px] h-[20px] roadCircle rounded-full ${element.status === 0 ? "bg-gray-500" : "bg-green-500"} absolute top-1/2 transform -translate-y-1/2`}
                                >

                                </div>
                                <div
                                    className={` roadLine ${index % 2 === 0
                                        ? "absolute left-[51%]"
                                        : "absolute left-[-51%]"
                                        }  top-1/2 h-[4px] ${element.status === 0 ? "bg-gray-500" : "bg-green-500"} z-[-1] transform translate-y-[-50%]`}
                                >

                                </div>
                                <div
                                    className={` RoadBox dark:border-white p-[5px]`}
                                    style={{
                                        boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                    }}
                                >

                                    <div className="flex flex-col items-center">
                                        <div className="boxx">
                                            <div className="flex items-center justify-start relative">
                                                <p className="text-center">{element.name}</p>
                                                <MilestoneComments
                                                    comments={element.comments || []}
                                                    milestoneName={element.name}
                                                />

                                            </div>


                                        </div>

                                    </div>
                                    <div className="raodDataMain">
                                        <div className="raodData">
                                            {element.status == 1 ? element.date && `Date : ${element.date}` : `ETA :${element.estimateddate}`}
                                        </div>


                                    </div>

                                </div>


                            </div>

                        ))}

                    </div>

                </div>
            </div></>}
        {ports.length > 0 && (<>

            <div className="roadLineFirstMain"><div className="roadLineFirst bg-green-500"></div></div>
            <div className="roadmapHeading ">
                <h3>Main Carriage</h3>
            </div>

            <div className="RoadMapMain RoadMapMainCarrige">
                {ports.map((port: any, portIndex: any) => (
                    <div
                        key={portIndex}
                        className={`RoadMapBox timeActivee ${port.status === 1
                            ? "OrangeActive"
                            : port.status === 2
                                ? "GreenActive"
                                : ""
                            }`}
                    >
                        <div className="circlRipple">
                            <div className="intro-banner-vdo-play-btn pinkBg">
                                <span className=" pinkBg"></span>
                                <span className=" pinkBg"></span>
                                <span className=" pinkBg"></span>
                            </div>
                        </div>
                        <div className="lineCustomOcean"></div>
                        <div className="RoadMapBoxInn">
                            <div className="RoadMapContent">
                                <div className="rooadTiitle">
                                    <h2>
                                        {`${port.portName}, ${port.events?.[0]?.portType}` ||
                                            ""}
                                    </h2>

                                    {port.reScheduleVessel !==
                                        null && (
                                            <div className="historyIconnew">
                                                <HistoryIcon
                                                    style={{
                                                        fontSize: "18px",
                                                        cursor: "pointer",
                                                        color: "#FFA500",
                                                    }}
                                                    onClick={() =>
                                                        handleHistoryOpenNew(
                                                            port,
                                                            portIndex
                                                        )
                                                    }
                                                />

                                                {showHistoryBoxNew &&
                                                    dialogIndexNew ===
                                                    portIndex && (
                                                        <div
                                                            id="historyIconIdNew"
                                                            style={{
                                                                position: "absolute",
                                                                left: "25px",
                                                                top: "0",
                                                                width: "180px",
                                                                height: "150px",
                                                                backgroundColor:
                                                                    "#f7f6f0",
                                                                border:
                                                                    "1px solid #ccc",
                                                                zIndex: 1000,
                                                                padding: "0",
                                                            }}
                                                        >
                                                            <div>
                                                                <pre
                                                                    style={{
                                                                        whiteSpace:
                                                                            "pre-wrap",
                                                                        wordWrap:
                                                                            "break-word",
                                                                        fontFamily:
                                                                            "monospace",
                                                                        fontSize: "12px",
                                                                    }}
                                                                >
                                                                    <div className=" roaddTtittle border-b-1 border-gray-300 font-bold text-[90%] text-center bg-yellow-100 ">
                                                                        {`${port.portName}, ${port.events?.[0]?.portType}` ||
                                                                            ""}
                                                                    </div>
                                                                    <div className="planVessalDetailouter p-1">
                                                                        <div className="planVessalDetail">
                                                                            <div className="actualtittle">
                                                                                Planned Vessal
                                                                            </div>
                                                                            <div>
                                                                                {port.reScheduleVessel && (
                                                                                    <div className="detailbottom">
                                                                                        <h6>
                                                                                            <b>
                                                                                                ETA :{" "}
                                                                                            </b>
                                                                                            <span className="text-gray-700 inline-block">
                                                                                                {port?.eta ||
                                                                                                    "N/A"}{" "}
                                                                                                <br />
                                                                                                {port.reScheduleVessel &&
                                                                                                    port.reScheduleVessel?.scheduleVessels?.map(
                                                                                                        (
                                                                                                            element: any
                                                                                                        ) => (
                                                                                                            <del>
                                                                                                                {
                                                                                                                    element.oldEta
                                                                                                                }
                                                                                                            </del>
                                                                                                        )
                                                                                                    )}
                                                                                            </span>
                                                                                        </h6>

                                                                                        <h6>
                                                                                            <b>
                                                                                                ETD :{" "}
                                                                                            </b>
                                                                                            <span className="text-gray-700 inline-block">
                                                                                                {port?.etd ||
                                                                                                    "N/A"}{" "}
                                                                                                <br />
                                                                                                {port.reScheduleVessel &&
                                                                                                    port.reScheduleVessel?.scheduleVessels?.map(
                                                                                                        (
                                                                                                            element: any
                                                                                                        ) => (
                                                                                                            <del>
                                                                                                                {
                                                                                                                    element.oldEtd
                                                                                                                }
                                                                                                            </del>
                                                                                                        )
                                                                                                    )}
                                                                                            </span>
                                                                                        </h6>
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className="actualtittle">
                                                                                Actual Vessal
                                                                            </div>
                                                                            <h6>
                                                                                <b>ATA :</b>
                                                                                <span className="text-gray-700">
                                                                                    {" "}
                                                                                    {port
                                                                                        .events[0]
                                                                                        ?.status
                                                                                        ? port
                                                                                            .events[0]
                                                                                            ?.date
                                                                                        : "N/A"}
                                                                                </span>
                                                                            </h6>
                                                                            <h6>
                                                                                <b>ATD :</b>
                                                                                <span className="text-gray-700">
                                                                                    {" "}
                                                                                    {port.events
                                                                                        .length >=
                                                                                        3 &&
                                                                                        port.events[
                                                                                            port
                                                                                                .events
                                                                                                .length -
                                                                                            1
                                                                                        ]?.status
                                                                                        ? port
                                                                                            .events[
                                                                                            port
                                                                                                .events
                                                                                                .length -
                                                                                            1
                                                                                        ]?.date
                                                                                        : "N/A"}{" "}
                                                                                </span>
                                                                            </h6>
                                                                        </div>
                                                                    </div>
                                                                </pre>
                                                            </div>
                                                            <button
                                                                onClick={
                                                                    handleHistoryCloseNew
                                                                }
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    bottom: "5px",
                                                                    right: "5px",
                                                                    background:
                                                                        "transparent",
                                                                    border: "none",
                                                                    cursor: "pointer",
                                                                    fontSize: "14px",
                                                                    fontWeight: "bold",
                                                                    color: "#1E88E5",
                                                                }}
                                                            >
                                                                close
                                                            </button>
                                                        </div>
                                                    )}
                                            </div>
                                        )}

                                    <i className="toparrow"></i>
                                </div>
                                <div className="RoadMapText paddingOcean rounded-lg p-2 relative">
                                    <div className="RoadMapTextInn">
                                        {port.events.length === 0 ? (
                                            <p>Details Awaited</p>
                                        ) : (
                                            port.events?.map(
                                                (
                                                    event: any,
                                                    eventIndex: any
                                                ) => (
                                                    <p
                                                        key={eventIndex}
                                                        className="flex"
                                                    >
                                                        <i className="bg-orange-100 rounded-full w-[20px] h-[20px] p-0  inline-block text-center mr-2">
                                                            <Ship
                                                                className={`w-[13px] h-[18px] inline-block ${event.status === 1
                                                                    ? "text-green-600"
                                                                    : "text-gray-700"
                                                                    }`}
                                                            />
                                                        </i>
                                                        <small className="text-[12px] w-[90%]">
                                                            {" "}
                                                            {
                                                                event.milestone
                                                            } on{" "}
                                                            {event.date || ""}
                                                        </small>
                                                    </p>
                                                )
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div></>)}

        {firstAndLast.last.length > 0 && <>
            {/* <div className="roadLineAfterMain"><div className="roadLineAfter bg-green-500"></div></div> */}
            <div className="roadmapHeading ">
                <h3>On-Carriage</h3>
            </div>
            <div className="RoadMap RoadMapOnCarrige">
                <div className="relative mx-auto max-w-screen-lg px-0  lg:px-3 ms:px-3 sm:px-0">
                    <div className="relative justify-between mb-[0px] text-xs">
                        <div className="bg-green-500"></div>

                        {firstAndLast.last.map((element: any, index: number) => (


                            <div
                                key={index}
                                className="relative roadinn flex flex-col items-center w-full mb-5"
                            >
                                <div
                                    className={`w-[20px] h-[20px] roadCircle rounded-full ${element.status === 0 ? "bg-gray-500" : "bg-green-500"} absolute top-1/2 transform -translate-y-1/2`}
                                >

                                </div>
                                <div
                                    className={` roadLine ${index % 2 === 0
                                        ? "absolute left-[51%]"
                                        : "absolute left-[-51%]"
                                        }  top-1/2 h-[4px] ${element.status === 0 ? "bg-gray-500" : "bg-green-500"} z-[-1] transform translate-y-[-50%]`}
                                >

                                </div>
                                <div
                                    className={` RoadBox dark:border-white p-[5px]`}
                                    style={{
                                        boxShadow: "rgba(0, 0, 0, 0.20) 0px 3px 10px",
                                    }}
                                >
                                    <div className="flex flex-col items-center">
                                        <div className="boxx">
                                            <div className="flex items-center justify-start relative">
                                                <p className="text-center">{element.name}</p>
                                                <MilestoneComments
                                                    comments={element.comments || []}
                                                    milestoneName={element.name}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                    <div className="raodDataMain">
                                        <div className="raodData">
                                            {element.status == 1 ? element.date && `Date : ${element.date}` : `ETA :${element.estimateddate}`}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>

            </div>
        </>
        }
    </>
}

export default OceanMileStoneTracking